/* oxlint-disable */
import {
  FaDice, FaGrinHearts, FaHeart, FaRegGrinStars,
} from 'react-icons/fa';
import {
  FaRankingStar, FaCircleDollarToSlot, FaSackDollar, FaStar,
} from 'react-icons/fa6';

import { GiChart, GiCardRandom } from 'react-icons/gi';

import { GrGamepad } from 'react-icons/gr';
import { IoNuclearOutline } from 'react-icons/io5';
import { LiaTrophySolid } from 'react-icons/lia';
import {
  MdLiveTv, MdRecommend, MdGames, MdLocationOn,
} from 'react-icons/md';
import { PiShootingStarLight } from 'react-icons/pi';

import { TbFileCertificate } from 'react-icons/tb';

import { CarouselData, GameItem } from '@/interfaces/core';
import { useAuthStore } from '@/stores/userStore';
import { hasValidFreeSpinForGame } from '@/utils/casinoFreeSpinAccess';
import { isGameCurrencyMismatch } from '@/utils/currency';

interface TrackingEvent {
  recommendationId: string | null;
  gameId: string;
  gameProviderId: string;
  position: string;
  category: string;
  // sessionKey: string;
  playerId: string | null;
}

interface HandleLoginModalProps {
  session: any;
  account?: any;
  balance: any;
  item: GameItem;
  toggleLoginModal: any;
  toggleDepositSheet: any;
  toggleDepositModal: any;
  setIsModalOpen?: any;
  setIsAcceptModalUrl: any;
  toggleAcceptModal: any;
  categorySelected: string;
  router: any;
  gameIndex: number;
}

export const trackingEventsZinga = async (trackingEvents: TrackingEvent) => {
  const zingUser = process.env.ZING_API_USER;
  const zingPass = process.env.ZING_API_PASS;
  const zingBrandId = process.env.ZING_BRAND_ID;
  const baseUrl = process.env.ZING_API_BASE_URL;
  const auth = Buffer.from(`${zingUser}:${zingPass}`).toString('base64');

  const trackingUrl = `${baseUrl}/providers/${zingBrandId}/trackingEvents`;
  const eventPayload = {
    action: 'casino-game-open',
    uri: {
      recommendationId: trackingEvents.recommendationId,
    },
    parameters: {
      gameId: trackingEvents.gameId,
      gameProviderId: trackingEvents.gameProviderId,
      position: trackingEvents.position || '0',
      category: trackingEvents.category,
      playerId: trackingEvents.playerId,
      timestamp: Math.floor(Date.now() / 1000).toString(),
    },
  };

  console.log('eventPayload', eventPayload);

  try {
    const response = await fetch(trackingUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Basic ${auth}`,
      },
      body: JSON.stringify([eventPayload]),
    });

    console.log(await response.json(), 'response trackingEventsZinga');
  } catch (error) {
    console.log(error, 'error trackingEventsZinga');
    // lógica de reintento
    setTimeout(async () => {
      try {
        const retryResponse = await fetch(trackingUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Basic ${auth}`,
          },
          body: JSON.stringify([eventPayload]),
        });
        console.log(await retryResponse.json(), 'retry response trackingEventsZinga');
      } catch (retryError) {
        console.log(retryError, 'retry error trackingEventsZinga');
      }
    }, 1000);
  }
};

export const zingaCategoryMap: Record<string, string> = {
  'Para ti': 'Para ti',
  'Porque te gusta': 'Más como tu favorito',
  'Nuevos juegos que te van a gustar': 'Nuevos juegos para ti',
  'También te puede gustar': 'Tus gustos',
  'Juegos en tendencia': 'Tendencia',
  'Tus favoritos olvidados': 'Favoritos olvidados',
  'Tu mecánica favorita': 'Mecánica Favorita',
  'Lo mejor de tu proveedor favorito': 'Proveedor Favorito',
  'Los mejores juegos en tu ubicación': 'Mejores en tu ubicación',
  'Tus favoritos': 'Favoritos',
};

export const zingaCategoryMapReverse: Record<string, string> = {
  'Para ti': 'Para ti',
  'Más como tu favorito': 'Porque te gusta',
  'Nuevos juegos para ti': 'Nuevos juegos que te van a gustar',
  'Tus gustos': 'También te puede gustar',
  Tendencia: 'Juegos en tendencia',
  'Favoritos olvidados': 'Tus favoritos olvidados',
  'Mecánica Favorita': 'Tu mecánica favorita',
  'Proveedor Favorito': 'Lo mejor de tu proveedor favorito',
  'Mejores en tu ubicación': 'Los mejores juegos en tu ubicación',
  Favoritos: 'Tus favoritos',
};

export const allCategoriesMapped = {
  'Para ti': 'zing-para-ti',
  'Más como tu favorito': 'zing-mas-como-tu-favorito',
  'Nuevos juegos para ti': 'zing-nuevos-juegos-para-ti',
  'Tus gustos': 'zing-tus-gustos',
  Tendencia: 'zing-tendencia',
  'Favoritos olvidados': 'zing-favoritos-olvidados',
  'Tu mecánica favorita': 'zing-tu-mecanica-favorita',
  'Lo mejor de tu proveedor favorito': 'zing-lo-mejor-de-tu-proveedor-favorito',
  'Los mejores juegos en tu ubicación': 'zing-los-mejores-juegos-en-tu-ubicacion',
  Favoritos: 'favoritos',
  'Todos los juegos': 'todos-los-juegos',
  Nuevos: 'nuevos',
  Crash: 'crash',
  Popular: 'popular',
  Live: 'live',
  Recomendados: 'recomendados',
  'Juega en Dolares': 'juega-en-dolares',
  'Rasca y Gana': 'rasca-y-gana',
  Tragamonedas: 'tragamonedas',
  Ruleta: 'ruleta',
  Cartas: 'cartas',
  Loteria: 'loteria',
  Dados: 'dados',
  Arcade: 'arcade',
  'Porque te gusta': 'zing-porque-te-gusta',
  'Nuevos juegos que te van a gustar': 'zing-nuevos-juegos-que-te-van-a-gustar',
  'También te puede gustar': 'zing-tambien-te-puede-gustar',
  'Juegos en tendencia': 'zing-juegos-en-tendencia',
  'Tus favoritos olvidados': 'zing-tus-favoritos-olvidados',
  'Tus favoritos': 'zing-tus-favoritos',
};

export const mapDynamicCategory = (category: string): string => {
  const dynamicCategoryPattern = /^Porque te gusta/;
  if (dynamicCategoryPattern.test(category)) {
    return 'zing-porque-te-gusta';
  }
  return allCategoriesMapped[category as keyof typeof allCategoriesMapped] || category;
};
export const sendTrackingEvent = (url: string, payload: any) => {
  // `void` silences the unawaited‐promise lint rule
  void fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
    .then((res) => {
      if (!res.ok) {
        console.error('Tracking failed:', res.statusText);
      }
    })
    .catch((err) => { return console.error('Tracking error:', err); });
};

export const handleLoginModal = async (handleLoginModalProps: HandleLoginModalProps) => {
  const {
    session, account, balance, item, toggleLoginModal,
    toggleDepositSheet, toggleDepositModal, toggleAcceptModal,
    setIsModalOpen, setIsAcceptModalUrl, router,
  } = handleLoginModalProps;

  // const categoryToTrackingEvents = mapDynamicCategory(categorySelected);
  const userCurrency = account?.currency || 'USD';

  const numericBalance = Number(balance?.[0]?.amount ?? 0);
  const hasBalance = Number.isFinite(numericBalance) && numericBalance > 0;
  const bonusSpins = useAuthStore.getState().bonuses?.spins;
  let canEnterGame = hasBalance;

  try {
    if (!hasBalance) {
      canEnterGame = hasValidFreeSpinForGame(bonusSpins, item.identifier);
    }
  } catch (error) {
    console.warn('freeSpin validation error:', error);
    canEnterGame = hasBalance;
  }

  // const userId = session?.user?.id;

  if (!session) {
    toggleLoginModal();
  } else if (session && !account.fullProfile) {
    setIsModalOpen(true);
  } else if (!canEnterGame) {
    if (window.innerWidth < 1000) {
      toggleDepositSheet();
    } else {
      toggleDepositModal();
    }
  } else if (isGameCurrencyMismatch(userCurrency, item.currency)) {
    // const eventPayload = {
    //   recommendationId: item.recommendationId || null,
    //   gameId: item.identifier,
    //   gameProviderId: item.provider,
    //   position: gameIndex || '',
    //   category: categoryToTrackingEvents || '',
    //   playerId: String(userId),
    // };

    // sendTrackingEvent(
    //   '/api/casino/trackingEvents',
    //   eventPayload,
    // );
    toggleAcceptModal();
    setIsAcceptModalUrl(`/casino/play?provider=${item?.provider}&gamecode=${item?.identifier}`);
  } else {
    // const eventPayload = {
    //   recommendationId: item.recommendationId || null,
    //   gameId: item.identifier,
    //   gameProviderId: item.provider,
    //   position: gameIndex || '',
    //   category: categoryToTrackingEvents || '',
    //   playerId: String(userId),
    // };

    // sendTrackingEvent(
    //   '/api/casino/trackingEvents',
    //   eventPayload,
    // );
    router.push(`/casino/play?provider=${item?.provider}&gamecode=${item?.identifier}`);
  }
};

export const specialCategories = [
  'Para ti',
  'Porque te gusta',
  'Nuevos juegos que te van a gustar',
  'También te puede gustar',
  'Juegos en tendencia',
  'Tus favoritos olvidados',
  'Tu mecánica favorita',
  'Lo mejor de tu proveedor favorito',
  'Los mejores juegos en tu ubicación',
  'Tus favoritos',
];

export const fetchForYouRecommendations = async (url: string) => {
  try {
    const response = await fetch(url);

    if (response.status !== 200) {
      throw new Error('Failed to fetch recommendations');
    }

    const data = await response.json();
    return data.recommendations;
  } catch (error) {
    console.log('errorFetch', error);
    throw new Error('Error fetching recommendations');
  }
};

export const IconsBurned: Record<string, React.ReactNode> = {
  scratch: <TbFileCertificate />,
  slots: <FaCircleDollarToSlot />,
  roulette: <IoNuclearOutline />,
  card: <GiCardRandom />,
  lottery: <LiaTrophySolid />,
  dice: <FaDice />,
  casual: <MdGames />,
  usd: <FaSackDollar />,
  recomendados: <MdRecommend />,
  news: <PiShootingStarLight />,
  live: <MdLiveTv />,
  crash: <GiChart />,
  popular: <FaRankingStar />,
  all: <GrGamepad />,
  recommend: <MdRecommend />,
  new: <FaRegGrinStars />,
  also: <MdLiveTv />,
  trending: <GiChart />,
  forgotten: <FaHeart />,
  mechanic: <MdLiveTv />,
  provider: <FaStar />,
  location: <MdLocationOn />,
  favorites: <FaGrinHearts />,
  default: <MdLiveTv />,
};

export const categoryMap: Record<string, string> = {
  'Juega en Dolares': '',
  'Rasca y Gana': 'scratch',
  Tragamonedas: 'slots',
  Ruleta: 'roulette',
  Cartas: 'card',
  Loteria: 'lottery',
  Dados: 'craps',
  Arcade: 'casual',
  'Todos los juegos': '',
  Crash: 'crash',
  Popular: 'popular',
  Nuevos: 'nuevos',
  Recomendados: 'recomendados',
  Live: 'live',
};

export interface CasinoTabProps {
  initialBanners: any[];
  games: any;
  initialCategories: any;
}

export interface GameDataResponse {
  gameData: GameItem[];
  sectionsGames: any[];
  totalGamesCount: number;
}

export type State = {
  searchData: string;
  selectedCategory: string;
  sections: CarouselData[];
  bgaming: GameItem[];
  filteredGames: GameItem[];
  isLoading: boolean;
  selectedProviders: string[];
};
